/**
 * Holiday daily times module
 *
 * @author MattJS(matt@yext.com)
 */
goog.provide('yext.location.custom.times.holiday');

goog.require('yext');
goog.require('yext.location.custom.times');
goog.require('yext.location.helpers');
goog.require('yext.location.hours');
/** @suppress {extraRequire} */
goog.require('yext.plugins.inputchange');
goog.require('yext.time');

goog.scope(function() {
  var _times = yext.location.custom.times;
  var _holiday = yext.location.custom.times.holiday;

  var MAX_HOLIDAY_TIMES = 100;

  /**
   * Represents a time within a holiday daily time field
   * @constructor
   * @param {!Object} data HolidayDailyTime model properties for initialization
   */
  _holiday.HolidayDailyTime = function(data) {
    _times.Time.call(this, data);
  };
  goog.inherits(_holiday.HolidayDailyTime, _times.Time);

  _holiday.HolidayDailyTime.prototype.namespace = 'holidaytime';

  /**
   * Make an update to the model
   *
   * @param {!Object} data The update
   */
  _holiday.HolidayDailyTime.prototype.update = function(data) {
    var changes = this.getChanges(data);
    if (changes) {
      if (changes.unspecified === true) {
        delete this.time;
        delete changes.time;
      } else if (changes.unspecified === false) {
        changes.time = '';
      }
      if (typeof changes.time != 'undefined') {
        delete this.unspecified;
        delete changes.unspecified;
      }

      $.extend(this, changes);
      this.broadcast(changes);
    }
  };

  /**
   * HolidayDailyTimeUI class
   *
   * @constructor
   * @param {!Object} model The related HolidayDailyTime model
   * @param {!jQuery} $element The DOM element
   */
  _holiday.HolidayDailyTimeUI = function(model, $element) {
    _times.TimeUI.call(this, model, $element);
  };
  goog.inherits(_holiday.HolidayDailyTimeUI, _times.TimeUI);

  /**
   * Get nested elements within $context
   */
  _holiday.HolidayDailyTimeUI.prototype.getElements = function() {
    this.$selected = this.$element.find('.js-time-selected');
    this.$date = this.$element.find('.js-holiday-date');
    this.$time = this.$element.find('.js-day-time');
    this.$unspecified = this.$element.find('.js-day-time-unspecified');
    this.$deleteButton = this.$element.find('.js-delete-time');
    this.$resetTimeIndeterminate = this.$element.find('.js-reset-indeterminate-times');

    // Unchecked is considered date indeterminate
    if (this.$selected.length && !this.$selected.prop('checked')) {
      this.$selected.prop('indeterminate', true);
    }
  };

  /**
   * Get model details from the DOM
   */
  _holiday.HolidayDailyTimeUI.prototype.modelFromElements = function() {
    this.model.date = this.$date.data('middle-endian');

    this.model.dateIndeterminate = !!this.$selected.length && !this.$selected.prop('checked');
    this.model.timeIndeterminate = !!this.$element.data('time-indeterminate');

    if (!this.model.timeIndeterminate) {
      if (this.$unspecified.prop('checked')) {
        this.model.unspecified = true;
      } else {
        this.model.time = this.$time.val();
      }
    }
  };

  /**
   * Render the UI
   */
  _holiday.HolidayDailyTimeUI.prototype.render = function() {
    var date = yext.time.validateDate(this.model.date);
    var dateString = date ? date.format('yMd') : this.model.date;

    if (this.$date.val() !== dateString) {
      this.$date.val(dateString);
    }

    if (!this.model.timeIndeterminate && this.$time.val() !== this.model.time) {
      this.$time.val(this.model.time);
    }

    if (this.$unspecified.prop('checked') != this.model.unspecified) {
      this.$unspecified.prop('checked', !!this.model.unspecified);
    }

    if (this.$time.prop('disabled') != !!this.model.unspecified) {
      this.$time.prop('disabled', !!this.model.unspecified);
    }

    if (this.model.dateIndeterminate) {
      this.$selected.prop('indeterminate', true);
    }
  };

  /**
   * Bind DOM element change events to the model
   */
  _holiday.HolidayDailyTimeUI.prototype.dataBindings = function() {
    var self = this;

    this.$time.inputchange(function() {
      self.model.update({
        time: self.$time.val(),
      });
    }).blur(function() {
      self.model.update({
        time: _times.formatTime(self.$time.val()),
      });
    });

    this.$unspecified.on('click change', function() {
      self.model.update({
        unspecified: self.$unspecified.prop('checked'),
      });
    });

    yext.time.newDatepicker(this.$date, function(date) {
      self.model.update({
        date: yext.time.formatDate(date),
      });
    }, {
      beforeShow: function(input, datepicker) {
        self.broadcast('beforeShowDatepicker', {
          datepicker: datepicker,
          timeUI: self,
        });
      },
    });
  };

  /**
   * Make a clone of the template
   * @return {!jQuery}
   */
  _holiday.HolidayDailyTimeUI.prototype.cloneTemplate = function() {
    if (this.model.timeIndeterminate) {
      return _holiday.HolidayDailyTimeUI.$holidayTimeIndeterminateTemplate.clone();
    } else {
      return _holiday.HolidayDailyTimeUI.$holidayTimeTemplate.clone();
    }
  };

  /**
   * Holiday Daily Times field class
   *
   * @constructor
   * @param {!jQuery} $element Context for the holiday daily times field
   */
  _holiday.HolidayDailyTimesField = function($element) {
    this.$element = $element;
    this.$timesContainer = $element.find('.js-holiday-times-container');
    this.$selectAllContainer = $element.find('.js-select-all-holiday-times-container');
    this.$selectAll = this.$selectAllContainer.find('.js-select-all-holiday-times');

    _holiday.HolidayDailyTimeUI.$holidayTimeTemplate = $($element.find('.js-holiday-time-template').html());
    _holiday.HolidayDailyTimeUI.$holidayTimeIndeterminateTemplate = $($element.find('.js-holiday-time-indeterminate-template').html());

    this.isBulkEdit = this.$selectAll.length;
    this.times = [];
    this.timesUI = [];

    this.build();
    this.storeValues();
    this.bindings();
    this.setSelectAll();
    this.toggleAddHolidayTimes();
  };

  _holiday.HolidayDailyTimesField.prototype.toggleAddHolidayTimes = function() {
    this.$element.find('.js-add-holiday-time').toggle(this.times.length < MAX_HOLIDAY_TIMES);
  };

  /**
   * Store the values so they can be restored if the field is reset
   */
  _holiday.HolidayDailyTimesField.prototype.storeValues = function() {
    var times = [];
    this.times.forEach(function(time) {
      times.push(time.ownProperties());
    });

    this.storedValues = {
      times: times,
    };
  };

  /**
   * Build UI and model classes from the DOM
   */
  _holiday.HolidayDailyTimesField.prototype.build = function() {
    var self = this;

    this.$element.find('.js-day-time-holiday').each(function() {
      self.newTime(new _holiday.HolidayDailyTimeUI(new _holiday.HolidayDailyTime(), $(this)));
    });
  };

  /**
   * Do field wide data bindings
   */
  _holiday.HolidayDailyTimesField.prototype.bindings = function() {
    var self = this;

    this.$element.find('.js-add-holiday-time').click(function() {
      var timeUI = new _holiday.HolidayDailyTimeUI(new _holiday.HolidayDailyTime());
      self.newTime(timeUI);
      self.$timesContainer.append(timeUI.$element);
      if (self.timesUI.length > 1) {
        self.$selectAllContainer.show();
        self.setSelectAll();
        self.updateTimeCount();
      }
      self.toggleAddHolidayTimes();
    });

    this.$selectAll.click(function() {
      var checked = self.$selectAll.prop('checked');
      self.timesUI.forEach(function(timeUI) {
        if (!timeUI.model.timeIndeterminate) {
          timeUI.$selected.prop({
            checked: checked,
            indeterminate: false,
          }).trigger('change');
        }
      });
      self.broadcast('updated');
    });
  };

  /**
   * Set the select all based upon other checkboxes
   */
  _holiday.HolidayDailyTimesField.prototype.setSelectAll = function() {
    var allChecked = true;
    for (var i = 0; i < this.times.length; i++) {
      if (this.times[i].timeIndeterminate !== true
          && (this.times[i].selected === false || this.times[i].dateIndeterminate)) {
        allChecked = false;
        break;
      }
    }
    this.$selectAll.prop('checked', allChecked);
  };

  /**
   * Update the count in the select all
   */
  _holiday.HolidayDailyTimesField.prototype.updateTimeCount = function() {
    this.$selectAllContainer.find('.js-holiday-time-count').html(this.timesUI.length);
  };

  /**
  * Add a new HolidayDailyTimeUI object and bind DOM element change events
  *
  * @param {!Object} timeUI HolidayDailyTimeUI object
  */
  _holiday.HolidayDailyTimesField.prototype.newTime = function(timeUI) {
    var self = this;

    this.times.push(timeUI.model);
    this.timesUI.push(timeUI);

    self.bindHolidayTimeUIUpdate(timeUI);
    self.bindHolidayTimeUISelect(timeUI);

    timeUI.$deleteButton.click(function(e) {
      e.stopPropagation();

      var uiIndex = self.timesUI.indexOf(timeUI);
      self.timesUI.splice(uiIndex, 1);

      var timeIndex = self.times.indexOf(timeUI.model);
      self.times.splice(timeIndex, 1);

      timeUI.destroy();
      self.broadcast('updated');
      self.toggleAddHolidayTimes();
    });

    if (timeUI.model.timeIndeterminate) {
      this.bindTimeIndeterminate(timeUI);
    }

    /**
     * To make setting dates easier, the month of the date picker will be set
     * to the month of the previously selected date
     */
    $(timeUI).on('beforeShowDatepicker', function(e, data) {
      var index = self.timesUI.indexOf(data.timeUI);
      if (index != 0) {
        var time = self.timesUI[index - 1].model;
        data.datepicker.settings.defaultDate = new Date(time.date);
      }
    });
  };

  /**
   * Bindings for indeterminate time case
   *
   * @param {!Object} timeUI HolidayDailyTimeUI object
   */
  _holiday.HolidayDailyTimesField.prototype.bindTimeIndeterminate = function(timeUI) {
    var self = this;

    timeUI.$resetTimeIndeterminate.click(function() {
      var newHolidayTimeUI = new _holiday.HolidayDailyTimeUI(new _holiday.HolidayDailyTime({date: timeUI.model.date}));
      timeUI.$element.replaceWith(newHolidayTimeUI.$element);

      var timeUIIndex = self.timesUI.indexOf(timeUI);
      var timeIndex = self.times.indexOf(timeUI.model);
      self.timesUI[timeUIIndex] = newHolidayTimeUI;
      self.times[timeIndex] = newHolidayTimeUI.model;

      self.broadcast('updated');

      self.bindHolidayTimeUIUpdate(newHolidayTimeUI);
      self.bindHolidayTimeUISelect(newHolidayTimeUI);
    });
  };

  /**
   * Bindings for HolidayDailyTime change
   *
   * @param {!Object} timeUI HolidayDailyTimeUI object
   */
  _holiday.HolidayDailyTimesField.prototype.bindHolidayTimeUIUpdate = function(timeUI) {
    var self = this;

    $(timeUI.model).on('updated.holidaytime', function() {
      timeUI.render();
      self.broadcast('updated');
    });
  };

  /**
   * Bindings for select checkbox change in bulk edit
   *
   * @param {!Object} timeUI HolidayDailyTimeUI object
   */
  _holiday.HolidayDailyTimesField.prototype.bindHolidayTimeUISelect = function(timeUI) {
    var self = this;

    timeUI.$selected.on('click change', function() {
      var index = self.times.indexOf(timeUI.model);
      self.times[index].dateIndeterminate = false;
      self.times[index].selected = timeUI.$selected.prop('checked');

      self.setSelectAll();
      self.broadcast('updated');
    });
  };

  /**
   * Get details about the field in its current state
   *
   * In the case of bulk edit only the times with selected == true will be included
   *
   * @return {!Object} Details about the holiday times field
   */
  _holiday.HolidayDailyTimesField.prototype.get = function() {
    if (this.isBulkEdit) {
      var times = [];
      this.times.forEach(function(time) {
        if (time.selected !== false) {
          times.push(time);
        }
      });
      return times;
    } else {
      return this.times;
    }
  };

  /**
   * Broadcast that a message about the field as a whole
   *
   * @param {string} message The type of message to send
   */
  _holiday.HolidayDailyTimesField.prototype.broadcast = function(message) {
    $(this).trigger(message + '.holidayTimes');
  };

  /**
   * Restore the field based upon the storedValues object
   */
  _holiday.HolidayDailyTimesField.prototype.reset = function() {
    this.reconcile(this.storedValues.times);
  };

  /**
   * Refresh the field based upon values passed
   *
   * @param {!Object} field Basic object that has holiday times field properties
   */
  _holiday.HolidayDailyTimesField.prototype.reconcile = function(field) {
    var self = this;

    for (var i = 0; i < this.times.length; i++) {
      this.times[i].destroy();
    }

    this.$timesContainer.empty();
    this.timesUI = [];
    this.times = [];

    field.forEach(function(holidayTime) {
      var timeUI = new _holiday.HolidayDailyTimeUI(new _holiday.HolidayDailyTime(holidayTime));
      self.newTime(timeUI);
      self.$timesContainer.append(timeUI.$element);
    });

    this.$selectAllContainer.toggle(this.timesUI.length > 1);
    this.setSelectAll();
    this.updateTimeCount();
    this.toggleAddHolidayTimes();
  };

  /**
   * Generate view markup
   *
   * @param {boolean} showInactive True if inactive message should be shown
   * @return {!jQuery} Table element
   */
  _holiday.HolidayDailyTimesField.prototype.generateViewMarkup = function(showInactive) {
    if (this.timesUI.length === 0) {
      return yext.location.helpers.emptyFieldMessage();
    }

    var table = [];

    this.times.forEach(function(time) {
      var dayOfWeek = yext.location.hours.dayOfWeek(time.date);
      var row = {
        // TRANSLATORS: The first parameter is a date and the second is the day of the week
        label: yext.msg('{0} ({1})', (new Date(time.date)).format('yMd'), yext.time.dayAbbreviations[dayOfWeek]),
      };

      if (time.dateIndeterminate || time.timeIndeterminate) {
        row.value = yext.location.helpers.variousContentMessage();
      } else if (time.unspecified) {
        row.value = yext.msg('None');
      } else {
        row.value = time.time;
      }

      table.push(row);
    });

    // Show inactive container if needed
    if (showInactive && this.$inactive) {
      return [this.$inactive.show(), _times.buildTimesTable(table)];
    }

    return _times.buildTimesTable(table);
  };

  /**
  * @param {!jQuery} $display The display container
  */
  _holiday.HolidayDailyTimesField.prototype.setDisplay = function($display) {
    this.$display = $display;
    this.$inactive = $display.find('.js-holiday-inactive-message');
  };

  /**
   * Create a new HolidayDailyTimesField object
   *
   * @param {!jQuery} $element The containing UI element for a daily times field
   * @return {DailyTimesField} Instance of a daily times field
   */
  _holiday.createHoliday = function($element) {
    return new _holiday.HolidayDailyTimesField($element);
  };
});
